import React from 'react';

const MuiCheckboxIndeterminateIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="4" y="4" width="16" height="16" rx="3" stroke="#4785FF" strokeWidth={2} />
    <rect x="6.75" y="11.25" width="10.5" height="2.25" rx="1.125" fill="#4785FF" />
  </svg>
);

export default MuiCheckboxIndeterminateIcon;
